import { useLayoutEffect, useState } from "react";
import type { CSSProperties, RefObject } from "react";
import { useMobile } from "../context/MobileContext";

// ── Popover placement for the top-bar bells ───────────────────────────────
// On desktop a panel hangs off its button (absolute, right-aligned, fixed
// width). On a phone the button sits close to the right edge, so the same
// geometry runs off the left of the screen: the panel is instead fixed across
// the viewport with a 12px gutter, just below the button (measured on open, so
// a banner above the top bar is accounted for) and never below the fold.

const MOBILE_GUTTER = 12;

export function usePopoverPlacement(open: boolean, buttonRef: RefObject<HTMLElement>, width = 340): CSSProperties {
  const isMobile = useMobile();
  const [top, setTop] = useState<number | null>(null);

  useLayoutEffect(() => {
    if (!open || !isMobile) { setTop(null); return; }
    const rect = buttonRef.current?.getBoundingClientRect();
    setTop(rect ? Math.round(rect.bottom + 8) : 62);
  }, [open, isMobile, buttonRef]);

  if (isMobile) {
    const y = top ?? 62;
    return {
      position: "fixed",
      top: y,
      left: MOBILE_GUTTER,
      right: MOBILE_GUTTER,
      width: "auto",
      maxHeight: `calc(100vh - ${y + MOBILE_GUTTER}px)`,
      overflowY: "auto",
    };
  }
  return { position: "absolute", top: "calc(100% + 8px)", right: 0, width };
}
